import moment from 'moment';

import AuthService from './AuthService';
import i18n from '../i18n';
import history from '../utils/customHistory';

export default class BaseService {
    // Initializing important variables
    constructor(domain) {
        if (domain !== null && domain !== undefined) {
            this.domain = domain;
        } else {
            this.domain = process.env.REACT_APP_BACKEND_URL; // API server domain
        }
        this.fetch = this.fetch.bind(this);
        this.setUiMethods = this.setUiMethods.bind(this);
        this.auth = new AuthService(this.domain);
        // eslint-disable-next-line no-extend-native
        Date.prototype.toJSON = function () {
            return moment(this).format('YYYY-MM-DDTHH:mm:ssZ');
        };
        this.counter = 0;
    }

    setUiMethods(blockUi, unblockUi, updateApp) {
        this.blockUi = blockUi;
        this.unblockUi = unblockUi;
        this.updateApp = updateApp;
    }

    getIp = async () => {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        return data.ip;
    };

    fetch(url, options, headers) {
        console.log('fetching ', url);
        // Funkcja do wykonania rzeczywistego żądania z obsługą odświeżenia tokena przy błędzie 401
        const executeFetch = () => {
            return this._actualFetch(url, options, headers, false)
                .then((response) => {
                    // Jeśli odpowiedź jest pomyślna lub błąd inny niż 401, zwróć odpowiedź

                    return response; // Zwróć odpowiedź dla pomyślnego żądania lub błędów innych niż 401
                })
                .catch((error) => {
                    if (error.status === 401) {
                        // Jeśli otrzymamy 401, próbujemy odświeżyć token i ponowić żądanie
                        console.log('Unauthorized - attempting to refresh token');
                        return this.auth
                            .refresh()
                            .then(() => {
                                console.log('Token refreshed - retrying fetch');
                                return this._actualFetch(url, options, headers, true); // Ponowne wysłanie żądania z odświeżonym tokenem
                            })
                            .catch((error) => {
                                // Nie udało się odświeżyć tokena
                                console.error('Failed to refresh token', error);
                                console.log('window.location.href=', window.location);
                                this.auth.logout(); // Wylogowanie użytkownika
                                console.log('redirect to login', window.location.pathname);
                                // Przekierowanie do strony logowania, jeśli nie jesteśmy już na niej
                                if (!window.location.pathname.startsWith('/login')) {
                                    //window.location.href.search='';
                                    window.location.href = '/login';
                                    //history.replace('/login');
                                }
                                return Promise.reject(error);
                            });
                    } else {
                        if (error.json) {
                            return Promise.reject(error.json);
                        }
                        return Promise.reject(error);
                    }
                });
        };

        // Bezpośrednie wykonanie żądania
        return executeFetch();
    }

    _actualFetch(url, options, headers, retrying) {
        const method = options !== undefined ? options.method : undefined;
        // performs api calls sending the required authentication headers
        if (headers === null || headers === undefined) {
            headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                locale: sessionStorage.getItem('i18nextLng')
            };
        }
        if (this.auth.loggedIn()) {
            headers['Authorization'] = this.auth.getToken();
        }
        if (method === 'POST' || method === 'PUT') {
            this.counter += 1;
            if (this.blockUi !== undefined) {
                this.blockUi();
            }
        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                headers,
                ...options,
            })
                .then((response) => this.parseJSON(response, headers))
                .then((response) => {
                    if (method === 'POST' || method === 'PUT') {
                        this.counter -= 1;
                        if (this.counter <= 0 && this.unblockUi !== undefined) {
                            this.unblockUi();
                        }
                    }
                    if (
                        response.ok &&
                        (headers === undefined || headers.accept === 'application/json' || headers.Accept === 'application/json')
                    ) {
                        return resolve(response.json);
                    } else if (
                        response.ok &&
                        (headers === undefined ||
                            headers.accept === 'application/octet-stream' ||
                            headers.Accept === 'application/octet-stream' ||
                            headers.accept === 'application/zip' ||
                            headers.Accept === 'application/zip')
                    ) {
                        return resolve(response.blob);
                    } else if (response.ok) {
                        return resolve(response.body);
                    }
                    return reject(response);
                })
                .catch((error) => {
                     console.log('error', error);
                    if (method === 'POST' || method === 'PUT') {
                        this.counter -= 1;
                        if (this.counter <= 0 && this.unblockUi !== undefined) {
                            this.unblockUi();
                        }
                    }
                    if (
                        error !== undefined &&
                        error !== null &&
                        error.message !== undefined &&
                        error.message !== null &&
                        (error.message.includes('NetworkError when attempting to fetch resource') ||
                            error.message.includes('Failed to fetch'))
                    ) {
                        error.message = 'komunikacji z serwerem podczas pobierania danych.';
                    }
                    reject(error);
                });
        });
    }

    parseJSON(response, headers) {
        return new Promise((resolve, reject) => {
            if (headers !== undefined && (headers.accept === 'application/json' || headers.Accept === 'application/json')) {
                response.json().then(
                    (json) => {
                        resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        });
                    },
                    (reason) => {
                        reject({
                            status: response.status,
                            ok: response.ok,
                            json: {message: reason},
                        });
                    }
                );
            } else if (
                headers !== undefined &&
                (headers.accept === 'application/octet-stream' ||
                    headers.Accept === 'application/octet-stream' ||
                    headers.accept === 'application/zip' ||
                    headers.Accept === 'application/zip')
            ) {
                resolve({
                    status: response.status,
                    ok: response.ok,
                    blob: response.blob(),
                });
            } else {
                resolve({
                    status: response.status,
                    ok: response.ok,
                    body: response.body,
                });
            }
        });
    }

    objToQueryString(obj) {
        const keyValuePairs = [];
        for (const key in obj) {
            if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
                keyValuePairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
            }
        }
        return (keyValuePairs.length > 0 ? '?' : '') + keyValuePairs.join('&');
    }

    getPath() {
        return `${this.domain}/${this.path}`;
    }

    persistMessage(severity, summary, detail) {
        this.saveCookie(
            'login-container',
            JSON.stringify({
                severity,
                summary,
                detail,
            })
        );
    }

    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    cloneElement(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
}
